import { XMarkIcon } from "@heroicons/react/20/solid";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import config from "config";
import { classNames, wrapClick, wrapImage } from "utils";
import axios from "axios";
import lodash from "lodash";
import numeral from "numeral";
import React, { FC, useCallback, useEffect, useState } from "react";
import { Accept, FileRejection, useDropzone } from "react-dropzone";
import toast from "react-hot-toast";

axios.defaults.baseURL = config.asset.uri;

const PdfSvg: FC<{ className: string }> = (props) => (
  <svg
    {...props}
    height="1em"
    viewBox="0 0 32 32"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m24.1 2.072l5.564 5.8v22.056H8.879V30h20.856V7.945z"
      fill="#909090"
    />
    <path d="M24.031 2H8.808v27.928h20.856V7.873z" fill="#f4f4f4" />
    <path d="M8.655 3.5h-6.39v6.827h20.1V3.5z" fill="#7a7b7c" />
    <path d="M22.472 10.211H2.395V3.379h20.077z" fill="#dd2025" />
    <path
      d="M9.052 4.534H7.745v4.8h1.028V7.715L9 7.728a2 2 0 0 0 .647-.117a1.4 1.4 0 0 0 .493-.291a1.2 1.2 0 0 0 .335-.454a2.1 2.1 0 0 0 .105-.908a2.2 2.2 0 0 0-.114-.644a1.17 1.17 0 0 0-.687-.65a2 2 0 0 0-.409-.104a2 2 0 0 0-.319-.026m-.189 2.294h-.089v-1.48h.193a.57.57 0 0 1 .459.181a.92.92 0 0 1 .183.558c0 .246 0 .469-.222.626a.94.94 0 0 1-.524.114m3.671-2.306c-.111 0-.219.008-.295.011L12 4.538h-.78v4.8h.918a2.7 2.7 0 0 0 1.028-.175a1.7 1.7 0 0 0 .68-.491a1.9 1.9 0 0 0 .373-.749a3.7 3.7 0 0 0 .114-.949a4.4 4.4 0 0 0-.087-1.127a1.8 1.8 0 0 0-.4-.733a1.6 1.6 0 0 0-.535-.4a2.4 2.4 0 0 0-.549-.178a1.3 1.3 0 0 0-.228-.017m-.182 3.937h-.1V5.392h.013a1.06 1.06 0 0 1 .6.107a1.2 1.2 0 0 1 .324.4a1.3 1.3 0 0 1 .142.526c.009.22 0 .4 0 .549a3 3 0 0 1-.033.513a1.8 1.8 0 0 1-.169.5a1.1 1.1 0 0 1-.363.36a.67.67 0 0 1-.416.106m5.08-3.915H15v4.8h1.028V7.434h1.3v-.892h-1.3V5.43h1.4v-.892"
      fill="#464648"
    />
    <path
      d="M21.781 20.255s3.188-.578 3.188.511s-1.975.646-3.188-.511m-2.357.083a7.5 7.5 0 0 0-1.473.489l.4-.9c.4-.9.815-2.127.815-2.127a14 14 0 0 0 1.658 2.252a13 13 0 0 0-1.4.288Zm-1.262-6.5c0-.949.307-1.208.546-1.208s.508.115.517.939a10.8 10.8 0 0 1-.517 2.434a4.4 4.4 0 0 1-.547-2.162Zm-4.649 10.516c-.978-.585 2.051-2.386 2.6-2.444c-.003.001-1.576 3.056-2.6 2.444M25.9 20.895c-.01-.1-.1-1.207-2.07-1.16a14 14 0 0 0-2.453.173a12.5 12.5 0 0 1-2.012-2.655a11.8 11.8 0 0 0 .623-3.1c-.029-1.2-.316-1.888-1.236-1.878s-1.054.815-.933 2.013a9.3 9.3 0 0 0 .665 2.338s-.425 1.323-.987 2.639s-.946 2.006-.946 2.006a9.6 9.6 0 0 0-2.725 1.4c-.824.767-1.159 1.356-.725 1.945c.374.508 1.683.623 2.853-.91a23 23 0 0 0 1.7-2.492s1.784-.489 2.339-.623s1.226-.24 1.226-.24s1.629 1.639 3.2 1.581s1.495-.939 1.485-1.035"
      fill="#dd2025"
    />
    <path d="M23.954 2.077V7.95h5.633z" fill="#909090" />
    <path d="M24.031 2v5.873h5.633z" fill="#f4f4f4" />
    <path
      d="M8.975 4.457H7.668v4.8H8.7V7.639l.228.013a2 2 0 0 0 .647-.117a1.4 1.4 0 0 0 .493-.291a1.2 1.2 0 0 0 .332-.454a2.1 2.1 0 0 0 .105-.908a2.2 2.2 0 0 0-.114-.644a1.17 1.17 0 0 0-.687-.65a2 2 0 0 0-.411-.105a2 2 0 0 0-.319-.026m-.189 2.294h-.089v-1.48h.194a.57.57 0 0 1 .459.181a.92.92 0 0 1 .183.558c0 .246 0 .469-.222.626a.94.94 0 0 1-.524.114m3.67-2.306c-.111 0-.219.008-.295.011l-.235.006h-.78v4.8h.918a2.7 2.7 0 0 0 1.028-.175a1.7 1.7 0 0 0 .68-.491a1.9 1.9 0 0 0 .373-.749a3.7 3.7 0 0 0 .114-.949a4.4 4.4 0 0 0-.087-1.127a1.8 1.8 0 0 0-.4-.733a1.6 1.6 0 0 0-.535-.4a2.4 2.4 0 0 0-.549-.178a1.3 1.3 0 0 0-.228-.017m-.182 3.937h-.1V5.315h.013a1.06 1.06 0 0 1 .6.107a1.2 1.2 0 0 1 .324.4a1.3 1.3 0 0 1 .142.526c.009.22 0 .4 0 .549a3 3 0 0 1-.033.513a1.8 1.8 0 0 1-.169.5a1.1 1.1 0 0 1-.363.36a.67.67 0 0 1-.416.106m5.077-3.915h-2.43v4.8h1.028V7.357h1.3v-.892h-1.3V5.353h1.4v-.892"
      fill="#fff"
    />
  </svg>
);

const WordSvg: FC<{ className: string }> = (props) => (
  <svg
    {...props}
    height="1em"
    viewBox="0 0 32 32"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        gradientTransform="translate(0 1720)"
        gradientUnits="userSpaceOnUse"
        id="vscodeIconsFileTypeWord0"
        x1="4.494"
        x2="13.832"
        y1="-1712.086"
        y2="-1695.914"
      >
        <stop offset="0" stopColor="#2368c4" />
        <stop offset=".5" stopColor="#1a5dbe" />
        <stop offset="1" stopColor="#1146ac" />
      </linearGradient>
    </defs>
    <path
      d="M28.806 3H9.705a1.19 1.19 0 0 0-1.193 1.191V9.5l11.069 3.25L30 9.5V4.191A1.19 1.19 0 0 0 28.806 3"
      fill="#41a5ee"
    />
    <path d="M30 9.5H8.512V16l11.069 1.95L30 16Z" fill="#2b7cd3" />
    <path d="M8.512 16v6.5l10.418 1.3L30 22.5V16Z" fill="#185abd" />
    <path
      d="M9.705 29h19.1A1.19 1.19 0 0 0 30 27.809V22.5H8.512v5.309A1.19 1.19 0 0 0 9.705 29"
      fill="#103f91"
    />
    <path
      d="M16.434 8.2H8.512v16.25h7.922a1.2 1.2 0 0 0 1.194-1.191V9.391A1.2 1.2 0 0 0 16.434 8.2"
      opacity="0.1"
    />
    <path
      d="M15.783 8.85H8.512V25.1h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191"
      opacity="0.2"
    />
    <path
      d="M15.783 8.85H8.512V23.8h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191"
      opacity="0.2"
    />
    <path
      d="M15.132 8.85h-6.62V23.8h6.62a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191"
      opacity="0.2"
    />
    <path
      d="M3.194 8.85h11.938a1.193 1.193 0 0 1 1.194 1.191v11.918a1.193 1.193 0 0 1-1.194 1.191H3.194A1.19 1.19 0 0 1 2 21.959V10.041A1.19 1.19 0 0 1 3.194 8.85"
      fill="url(#vscodeIconsFileTypeWord0)"
    />
    <path
      d="M6.9 17.988q.035.276.046.481h.028q.015-.195.065-.47c.05-.275.062-.338.089-.465l1.255-5.407h1.624l1.3 5.326a8 8 0 0 1 .162 1h.022a8 8 0 0 1 .135-.975l1.039-5.358h1.477l-1.824 7.748h-1.727l-1.237-5.126q-.054-.222-.122-.578t-.084-.52h-.021q-.021.189-.084.561t-.1.552L7.78 19.871H6.024L4.19 12.127h1.5l1.131 5.418a5 5 0 0 1 .079.443"
      fill="#fff"
    />
  </svg>
);

interface UploadBoxProps {
  id: string;
  multiple?: boolean;
  maxFiles?: number;
  maxSize?: number;
  minSize?: number;
  accept?: Accept;
  disabled?: boolean;
  label?: string;
  values: any;
  setFieldValue: any;
  setFieldError: any;
  setFieldTouched: any;
  handleBlur: any;
  errors?: any;
  touched?: any;
  className?: string;
  required?: boolean;
}

interface Upload extends File {
  path: any;
  preview: string;
  fileUrl: string;
  error: string;
  progress: number;
  loading: boolean;
}

const FileIconMappings = {
  "application/pdf": <PdfSvg className="w-full h-full" />,
  "application/msword": <WordSvg className="w-full h-full" />,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": (
    <WordSvg className="w-full h-full" />
  ),
};

export const UploadBox: React.FC<UploadBoxProps> = ({
  multiple = false,
  maxFiles = 5,
  maxSize = 1024 * 1024 * 5,
  minSize = 1,
  accept = {
    "image/*": [".png", ".jpeg", ".jpg"],
    "application/pdf": [".pdf"],
    "application/msword": [".doc", ".docx"],
  },
  errors,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  id,
  label,
  className = "",
  required,
}) => {
  const [files, setFiles] = useState<Upload[]>([]);
  const [, setLoading] = useState<boolean>(false);
  const [currentFilePointer, setCurrentFilePointer] = useState<
    number | undefined
  >(undefined);

  const removeFile = (_id: number) => () => {
    setFiles(lodash.filter(files, (file, index) => index !== _id));
    setFieldValue?.(
      id,
      lodash.filter(
        lodash.get(values, id, []) as string[],
        (file, index) => index !== _id,
      ),
    );
  };

  const updateFileProgress = (_id: number, progress: number) => {
    setFiles((files) =>
      lodash.map(files, (file, index) => {
        if (index === _id) {
          Object.assign(file, { progress, loading: true });
        }
        return file;
      }),
    );
  };

  const completeFile = (_id: number, fileUrl: string) => {
    setFiles((files) =>
      lodash.map(files, (file, index) => {
        if (index === _id) {
          Object.assign(file, { fileUrl, loading: false });
        }
        return file;
      }),
    );
  };

  const errorFile = (id: number, error: string) => {
    setFiles((files) =>
      lodash.map(files, (file, index) => {
        if (index === id) {
          Object.assign(file, { error, loading: false });
        }
        return file;
      }),
    );
  };

  const onDrop = useCallback(
    async (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
      setFieldTouched(false);
      if (!acceptedFiles.length) {
        setFieldError(
          id,
          lodash
            .chain(rejectedFiles)
            .map("errors")
            .flatten()
            .map("code")
            .map(lodash.startCase)
            .join(", ")
            .value(),
        );
        //Show a toast message for each rejected file
        lodash.forEach(rejectedFiles, (file) => {
          toast(
            JSON.stringify({
              type: "error",
              title: `Cannot upload file:${file.file.name} - ${lodash.startCase(
                file.errors[0].code,
              )}`,
            }),
          );
        });
        return;
      }
      setFiles((prev) =>
        multiple
          ? [
            ...prev,
            ...acceptedFiles.map((file: any) =>
              Object.assign(file, {
                preview: URL.createObjectURL(file),
                loading: true,
                // preview: new Blob([file], {type: file?.type})
              }),
            ),
          ]
          : acceptedFiles.map((file: any) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
              loading: true,
              // preview: new Blob([file], {type: file?.type})
            }),
          ),
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // files,
      multiple,
      id,
    ],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles,
    multiple,
    accept,
    maxSize,
    minSize,
    noClick: false,
    disabled: false,
  });

  useEffect(() => {
    const nextPointer = files.findIndex((file) => file?.loading);
    if (nextPointer !== -1) {
      setCurrentFilePointer(nextPointer);
    } else {
      setCurrentFilePointer(undefined);
    }
  }, [files]);

  useEffect(
    () => () => {
      // Make sure to revoke the Object URL to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file?.preview));
    },
    [files],
  );

  useEffect(() => {
    //Clear files if form is reset
    if (!lodash.get(values, id)) {
      setFiles([]);
    }
  }, [values, id]);

  useEffect(() => {
    async function uploadFiles() {
      if (currentFilePointer === undefined) {
        return;
      }
      setLoading(true);
      // upload image to server and return url
      const data = new FormData();
      const file = files[currentFilePointer];
      data.append("file", file);
      await axios
        .post("/upload", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / (progressEvent?.total ?? 0),
            );
            updateFileProgress(currentFilePointer, percentCompleted);
          },
        })
        .then(({ data }) => {
          completeFile(currentFilePointer, data);
          multiple
            ? setFieldValue?.(id, [...lodash.get(values, id, []), data])
            : setFieldValue?.(id, data);
        })
        .catch((err) => {
          console.log(err, "--ERROR__");
          errorFile(currentFilePointer, err?.message);
        });
      setLoading(false);
    }
    if (files.length && currentFilePointer !== undefined) {
      uploadFiles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFilePointer]);

  return (
    <>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label} {required ? <span className="text-red-500">*</span> : ""}
      </label>
      <div
        className={classNames(
          className,
          multiple ? "aspect-w-12 aspect-h-4 mt-1" : "",
        )}
      >
        <div className="flex space-x-2">
          <div
            {...getRootProps()}
            id={`${id}-dropzone`}
            className={classNames(
              multiple
                ? "group w-4/12 flex-shrink-0 border-2 border-gray-300 border-dashed rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 flex flex-col items-center justify-center space-y-1 bg-gray-50 group-hover:opacity-75"
                : "relative group flex-1 flex border-2 mt-1 border-gray-300 border-dashed rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 aspect-w-3 aspect-h-2 w-full",
            )}
          >
            <input
              {...getInputProps()}
              id={id}
              name={id}
              type="file"
              className="sr-only"
            />

            {!files.length || multiple ? (
              <div
                className={classNames(
                  !multiple
                    ? "space-y-1 flex flex-1 flex-col items-center justify-center text-center px-6 pt-5 pb-6"
                    : "",
                )}
              >
                <svg
                  className="mx-auto h-12 w-12 text-gray-400"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 48 48"
                  aria-hidden="true"
                >
                  <path
                    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {!isDragActive ? (
                  <>
                    <span className="cursor-pointer rounded-md text-sm font-medium text-primary-600 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500">
                      Upload a file
                    </span>
                    <p className="text-xs text-gray-700">or drag and drop</p>
                  </>
                ) : (
                  <p className="text-xs text-gray-500">Drop File Here</p>
                )}
              </div>
            ) : (
              <>
                <div className="flex-1">
                  {files?.[0]?.path?.split(".").pop() === "pdf" ? (
                    <embed
                      type="application/pdf"
                      className="object-cover object-top h-full w-full z-0"
                      src={
                        files?.[0]?.preview ||
                        (multiple
                          ? lodash.get(values, id)?.[0]
                          : lodash.get(values, id))
                      }
                    />
                  ) : (
                    <img
                      className="object-cover object-top h-full w-full z-0"
                      src={
                        files?.[0]?.preview ||
                        (multiple
                          ? lodash.get(values, id)?.[0]
                          : lodash.get(values, id))
                      }
                      alt="Hello"
                    />
                  )}
                </div>
                {(!files?.[0]?.fileUrl || !files?.[0]?.fileUrl) && (
                  <div className="p-3 absolute inset-x-0 top-0 z-50">
                    <div
                      className={classNames(
                        files?.[0]?.progress < 100
                          ? "bg-amber-100"
                          : "bg-green-100",
                        "rounded-full",
                      )}
                    >
                      <div
                        className={classNames(
                          files?.[0]?.progress < 100
                            ? "bg-amber-400"
                            : "bg-green-400",
                          "rounded-full h-full text-white p-0.5 text-xs text-center",
                        )}
                      >
                        {files?.[0]?.progress < 100 ? (
                          <span>Uploading</span>
                        ) : (
                          <span>Uploaded</span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {multiple ? (
            <div className="flex-1 flex border-primary-300 border-2 border-dashed rounded-md">
              <div className="flex-1 grid-cols-2 grid-rows-3 grid gap-3 p-2">
                {(files.length ? files : files).map(
                  (file: any, index: number) => (
                    <div
                      key={index}
                      className={classNames(
                        "relative border  rounded flex p-2 space-x-2",
                        file?.loading ? "border-blue-500" : "",
                        file?.error ? "border-red-500" : "",
                        file?.fileUrl ? "border-green-500" : "",
                      )}
                    >
                      <div className="flex-shrink-0 w-1/4">
                        <div className="aspect-h-1 aspect-w-1">
                          {Object.keys(FileIconMappings).includes(
                            file?.type,
                          ) ? (
                            <button
                              disabled={!file?.fileUrl}
                              className="cursor-pointer "
                              onClick={wrapClick(() =>
                                window.open(file?.fileUrl),
                              )}
                              type="button"
                            >
                              {
                                FileIconMappings[
                                  file?.type as keyof typeof FileIconMappings
                                  ]
                              }
                            </button>
                          ) : (
                            <div className=" w-full h-full overflow-hidden [&_*]:!w-full [&_*]:!h-full">
                              {wrapImage(
                                <img
                                  className="rounded-md object-cover object-center border"
                                  src={file?.preview || file}
                                  alt="Hello"
                                />,
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className=" w-[calc(75%-0.5rem)] flex-1 flex flex-col justify-between">
                        <div className="flex justify-between w-full">
                          <div className="w-[calc(100%-1.3rem)] flex flex-col items-start ">
                            <p className="text-xs line-clamp-1 max-w-full overflow-ellipsis">
                              {file?.name}
                            </p>
                            <span className="text-xs text-gray-500 font-light">
                              {numeral(file?.size).format("0.0 b")}
                            </span>
                          </div>
                          <button
                            type="button"
                            onClick={wrapClick(removeFile(index))}
                            className=" shrink-0 rounded-full bg-red-600 p-0.5 h-min text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                          >
                            <XMarkIcon aria-hidden="true" className="h-3 w-3" />
                          </button>
                        </div>
                        <div className="flex items-center space-x-1.5">
                          <div className="bg-primary-50 rounded-full h-2 flex-1 ">
                            <div
                              className={classNames(
                                "rounded-full w-0 origin-left  h-full transition-all",
                                file?.fileUrl ? "bg-green-500" : "",
                                file?.error ? "bg-red-500" : "",
                                file?.progress <= 100 &&
                                !file?.error &&
                                !file?.fileUrl
                                  ? "bg-primary-500"
                                  : "",
                              )}
                              style={{
                                width: `${file?.progress}%`,
                              }}
                            />
                          </div>
                          <div className="text-xs">
                            {file?.error ? (
                              <ExclamationCircleIcon className="w-4 h-4 text-red-500 stroke-[2px]" />
                            ) : file?.fileUrl ? (
                              <CheckCircleIcon className="w-4 h-4 text-green-500 stroke-[2px]" />
                            ) : (
                              ""
                            )}
                            {file?.progress <= 100 &&
                            !file?.error &&
                            !file?.fileUrl
                              ? `${file?.progress}%`
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {lodash.get(errors, id) && lodash.get(touched, id) ? (
        <p className="mt-2 text-sm text-red-600" id={`${id}-error`}>
          {lodash.get(errors, id)}
        </p>
      ) : null}
    </>
  );
};

export default UploadBox;
